import { spacing, Text } from '@scality/core-ui';
import { Box } from '@scality/core-ui/dist/next';
import { parseInstanceMarker } from '../../../portal/instanceMarker';
import { InstanceBadge } from '../../InstanceBadge';

/** One member. A deployment id becomes the badge the chat prose uses for it. */
const LegendValue = ({ value }: { value: string }) => {
  const instanceId = parseInstanceMarker(value);
  return instanceId ? <InstanceBadge id={instanceId} /> : <Text>{value}</Text>;
};

/**
 * What the values apply to, read under the bar the way a chart's legend is read under it — one
 * wrapping row, 8px between entries, `Text` at its default size: `ChartLegend`'s metrics.
 *
 * Not `ChartLegend` itself, which draws a colour swatch per entry and filters that series on a
 * click: the members here are summed into a single bar, so there is no colour of theirs to show
 * and no series to filter.
 */
export const Legend = ({ legend }: { legend: string[] }) => (
  <Box display="flex" flexWrap="wrap" alignItems="center" gap={spacing.f8}>
    {legend.map((value) => (
      <LegendValue key={value} value={value} />
    ))}
  </Box>
);
